import React from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";
import { compose } from "recompose";
import { showModal } from "../../../redux/actions";
import ExpireSubscriptionModal from "../ExpireSubscriptionModal";

const ExpireSubscriptionMenuItem = ({ intl, subscriber, onComplete }) => {
  const dispatch = useDispatch();
  const onClick = () => {
    dispatch(showModal(ExpireSubscriptionModal, { subscriber: subscriber }));
    onComplete();
  };

  return (
    <MenuItem
      onClick={() => {
        onClick();
      }}
    >
      {intl.formatMessage({ id: "app.subscriber.expireSubscriptionMenuItem" })}
    </MenuItem>
  );
};

const enhance = compose(injectIntl);

export default enhance(ExpireSubscriptionMenuItem);
